
import {
  Document
} from '../types';

function filterDocumentsBy(documentList: Document[], filter: any): string[] {
  let matchedDocs: string[] = [];
  documentList.forEach((doc) => {
    let match = true;
    Object.entries(filter).forEach(([key, value]) => {
      if ((doc as any)[key] !== value) match = false;
    });
    if (match) matchedDocs.push(doc.id);
  })

  return matchedDocs;
}

export default filterDocumentsBy;